import type {AppLanguage} from '@/shared/lib/appLanguageSupports';

const LOCALIZED_OG_LOCALES: Partial<Record<AppLanguage, string>> = {
  en: 'en_US',
  es: 'es_ES',
  'pt-br': 'pt_BR',
  de: 'de_DE',
  tr: 'tr_TR',
  ja: 'ja_JP',
  id: 'id_ID',
  th: 'th_TH',
  it: 'it_IT',
  fr: 'fr_FR',
};

export function getLocalizedOgLocale(
  language: AppLanguage
): string | undefined {
  return LOCALIZED_OG_LOCALES[language];
}
